export default "__VITE_ASSET__B7HbBkK6__"